/** Platform-wide: Latin/English digits only (0-9), even in Arabic UI. */
export const NUMBER_LOCALE = 'en-US';

const ARABIC_INDIC = /[٠-٩]/g;
const EXTENDED_ARABIC_INDIC = /[۰-۹]/g;

/** Convert Arabic-Indic / Eastern digits in any string to Latin 0-9. */
export function toLatinDigits(value: string): string {
  return value
    .replace(ARABIC_INDIC, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(EXTENDED_ARABIC_INDIC, (d) => String(d.charCodeAt(0) - 0x06f0));
}

export function formatNumber(value: unknown, options?: Intl.NumberFormatOptions): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return toLatinDigits(String(value ?? '—'));
  return n.toLocaleString(NUMBER_LOCALE, options);
}

export function formatMoneyAmount(value: unknown, fractionDigits?: number): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return toLatinDigits(String(value ?? '—'));
  if (fractionDigits !== undefined) {
    return n.toLocaleString(NUMBER_LOCALE, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  }
  return n.toLocaleString(NUMBER_LOCALE);
}

export function formatDateTime(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '—';
  const d = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T'));
  if (Number.isNaN(d.getTime())) return toLatinDigits(raw);
  return toLatinDigits(
    d.toLocaleString(NUMBER_LOCALE, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }),
  );
}

export function str(v: unknown, fallback = '—'): string {
  if (v === null || v === undefined || v === '') return fallback;
  return toLatinDigits(String(v));
}

export function num(v: unknown): number {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `ord-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function required(fields: Record<string, string>, names: string[]): string | null {
  for (const name of names) {
    if (!String(fields[name] ?? '').trim()) {
      return 'يرجى تعبئة جميع الحقول المطلوبة.';
    }
  }
  return null;
}
